import React, { useEffect, useState } from "react";
import "./style.css";

import Group365 from "../../Assets/About/365 Group.png";
import luxuryLogo from "../../Assets/About/Luxury Homes Logo.png";
import ConciergeImg from "../../Assets/About/Concierge.png";
import LaundryImg from "../../Assets/About/Laundry.png";
import CleanItImg from "../../Assets/About/Clean It.png";
import maintenanceImg from "../../Assets/About/maintenance.png";

import section1 from "../../Assets/About/luxury homes section img.png";
import section2 from "../../Assets/About/Concierge img.png";
import section3 from "../../Assets/About/Laundry img.png";
import section4 from "../../Assets/About/clean img.png";
import section5 from "../../Assets/About/maintenance img.png";

import { Link } from "react-router-dom";
import axios from "axios";
import DynamicSeoPage from "../DynamicSeoPage";

const FALLBACK_WELCOME = {
  title: "Welcome to",
  description:
    "Born out of a commitment to elevating daily lifestyle, 365 Group's offerings span hospitality, personalised concierge services, dry-cleaning, maintenance, and more, as a testament to our relentless dedication to quality. We understand that luxury is not just about aesthetics but about the experience and emotions it evokes. Every property we curate and every service we provide is thoughtfully designed to make our clients and guests feel valued, understood, and well-served.",
};

const FALLBACK_SUBSIDIARIES = [
  {
    name: "365 Luxury Homes",
    logo: luxuryLogo,
    description:
      "If you can imagine your perfect stay in Dubai, 365 Luxury Homes can make it happen. We are committed to finding spaces that suit your style and setting a new global quality mark for vacation homes. From exclusive, beachfront stays on Palm Jumeirah to short-term or long-term holiday home apartments in Downtown, 365 Luxury Homes has all your requirements covered. Our concierge service can assist with special requests, and creating a custom holiday itinerary.",
    image: section1,
    link: "https://wa.me/971585173365",
    buttonText: "Know More",
    cssClass: "luxury_homes",
    bgPosition: "right",
  },
  {
    name: "Concierge",
    logo: ConciergeImg,
    description:
      "Our luxury concierge means home-made hospitality, personalised for you, with insider tips from local experts. Our finest designer properties and hand-picked villas, provisioned by our team, ensure that every stay meets our quality standards. With the facilities and services of a five-star hotel but the space and privacy of a real home, our luxury concierge team is pioneering new standards of service. We assist with everything from transport and tours to shopping and in-house dining.",
    image: section2,
    link: "https://wa.me/971585173365",
    buttonText: "Know More",
    cssClass: "luxury_concierge",
    bgPosition: "left",
  },
  {
    name: "Laundry",
    logo: LaundryImg,
    description:
      "The markets we service include residential communities and short-term rental properties, with services including the supply and laundering of bed linen, towels, and table linen as well as the laundering and dry cleaning of clothing. We pride ourselves on using the latest innovative technology that gives us the capability and capacity to handle a wide range of laundry demands at a cost-effective and highly hygienic level. We offer complete solutions to match any service requirements.",
    image: section3,
    link: "https://wa.me/971547416365",
    buttonText: "Know More",
    cssClass: "laundry_365",
    bgPosition: "right",
  },
  {
    name: "Clean It",
    logo: CleanItImg,
    description:
      "Our premier cleaning solutions are backed by industry experience which positioned us as a trusted name in the field of professional cleaning services. Our goal is to provide quality, proficiency, and affordability to deliver a spotless environment to enjoy and be productive in. Utilising the latest equipment and environmentally friendly cleaning products, we offer services spanning regular domestic cleaning, dusting, vacuuming, mopping, and bathroom and kitchen sanitisation. Superior protection means we prioritise safety and security with rigorous standards.",
    image: section4,
    link: "https://wa.me/",
    buttonText: "Know More",
    cssClass: "cleanit_365",
    bgPosition: "left",
  },
  {
    name: "Maintenance",
    logo: maintenanceImg,
    description:
      "Our premier maintenance solutions come with trained technicians who meet our brand's high standards for service and customer satisfaction. Our services cover repairs and maintenance of property or assets, including external property maintenance, roof, walls, floors, windows, ceiling, and other fixtures and fittings. Our ability to identify and diagnose existing or potential problems is standard procedure, backed by quality workmanship and reliability. Providing comprehensive maintenance solutions, we service households of all sizes across Dubai.",
    image: section5,
    link: "https://wa.me/971551211375",
    buttonText: "Know More",
    cssClass: "maintenance_365",
    bgPosition: "right",
  },
];

const About = () => {
  const [loading, setLoading] = useState(false);
  const [section, setSection] = useState({});
  const [welcome, setWelcome] = useState(FALLBACK_WELCOME);
  const [subsidiaries, setSubsidiaries] = useState(FALLBACK_SUBSIDIARIES);
  const [isDynamic, setIsDynamic] = useState(false);

  // Fetch banner image (existing behavior)
  useEffect(() => {
    const fetchSection = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://365luxuryhomes.com/api/sections/about_us`,
        );
        if (response.data) {
          setSection(response.data);
        }
      } catch (error) {
        // silently use default
      } finally {
        setLoading(false);
      }
    };
    fetchSection();
  }, []);

  // Fetch dynamic about page content
  useEffect(() => {
    const controller = new AbortController();
    axios
      .get("https://365luxuryhomes.com/api/about-page", {
        signal: controller.signal,
      })
      .then((res) => {
        if (res.data) {
          if (res.data.welcomeTitle || res.data.welcomeDescription) {
            setWelcome((prev) => ({
              title: res.data.welcomeTitle || prev.title,
              description: res.data.welcomeDescription || prev.description,
            }));
          }
          if (res.data.subsidiaries && res.data.subsidiaries.length > 0) {
            setIsDynamic(true);
            setSubsidiaries((prev) => {
              return res.data.subsidiaries.map((apiSub, idx) => {
                const fallback = prev[idx] || prev[0];
                return {
                  name: apiSub.name || fallback.name,
                  logo: apiSub.logo || fallback.logo,
                  description: apiSub.description || fallback.description,
                  image: apiSub.image || fallback.image,
                  link: apiSub.link || fallback.link,
                  buttonText:
                    apiSub.buttonText || fallback.buttonText || "Know More",
                  cssClass: fallback.cssClass || "",
                  bgPosition:
                    fallback.bgPosition || (idx % 2 === 0 ? "right" : "left"),
                };
              });
            });
          }
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <div>
      <DynamicSeoPage page="about-us" defalut={"About Us - 365 Luxury Homes"} />
      <section
        className="about_banner pt-20 pb-10 relative"
        id="banner"
        style={{
          backgroundImage: `url(${section?.imageUrl || ""})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {loading && (
          <div className="skeleton h-full w-full absolute top-0 left-0 -z-0"></div>
        )}
        <div className="container h-full flex items-end lg:justify-normal md:justify-normal justify-center">
          <h1 className="font-bold text-3xl text-white uppercase lg:text-left md:text-left text-center">
            About Us
          </h1>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="py-10 pt-20">
        <div className="container flex lg:flex-row md:flex-row flex-col lg:items-start md:items-start items-center lg:gap-10 md:gap-6 gap-8">
          <div className="lg:w-[50%] md:w-[40%]">
            <div className="flex lg:items-start md:items-start items-center gap-2 lg:-ml-20 lg:mb-8 md:mb-6 mb-4">
              <div className="lg:w-20 md:w-14 w-14 h-[2px] bg-[#aca9a5]"></div>
              <h2 className="text-2xl font-semibold text-[#74716d] uppercase leading-none -mt-1">
                {welcome.title}
              </h2>
            </div>
            <img src={Group365} alt="" className="w-56" />
          </div>
          <div className="lg:w-[50%] md:w-[60%]">
            <p className="text-[#74716d] text-[16px] leading-[24px] font-thin lg:text-left md:text-left text-center">
              {welcome.description}
            </p>
          </div>
        </div>
      </section>

      {/* Subsidiary Sections */}
      {subsidiaries.map((sub, idx) => {
        const isReversed = idx % 2 !== 0;
        const sectionCss = sub.cssClass || "";
        // Check if this section's image is a remote URL (dynamic from dashboard)
        const isRemoteImage =
          typeof sub.image === "string" && sub.image.startsWith("http");
        // Build inline style for dynamic background image override on desktop
        const sectionStyle =
          isDynamic && isRemoteImage
            ? {
                backgroundImage: `url(${sub.image})`,
                backgroundPosition:
                  sub.bgPosition || (isReversed ? "left" : "right"),
                backgroundSize: "50%",
                backgroundRepeat: "no-repeat",
                minHeight: "600px",
                width: "100%",
              }
            : {};

        return (
          <section
            key={idx}
            className={`${isDynamic ? "" : sectionCss} ${idx === 0 ? "mt-20" : "lg:pt-0 md:pt-16 pt-10"} flex items-center about-sub-section`}
            style={sectionStyle}
          >
            <div
              className={`container flex ${
                isReversed
                  ? "lg:flex-row md:flex-col-reverse flex-col-reverse"
                  : "lg:flex-row md:flex-col flex-col"
              } ${idx === 0 ? "lg:items-start md:items-start" : ""} items-center h-full ${
                idx === 0
                  ? "lg:gap-0 md:gap-8 gap-6"
                  : "lg:gap-0 md:gap-10 gap-8"
              }`}
            >
              {isReversed ? (
                <>
                  <div className="lg:w-[50%] md:w-full w-full h-full">
                    <img src={sub.image} alt="" className="lg:hidden" />
                  </div>
                  <div className="lg:w-[50%] md:w-full w-full h-full lg:pl-20">
                    <div className="h-full flex flex-col lg:items-start md:items-start items-center justify-center">
                      <img src={sub.logo} alt="" className="w-56" />
                      <p className="text-[#74716d] text-[16px] leading-[24px] font-thin lg:mt-8 md:mt-8 mt-8 lg:text-left md:text-left text-center">
                        {sub.description}
                      </p>
                      <Link
                        to={sub.link}
                        target="_blank"
                        className="bg-[#aca9a5] uppercase text-white mt-8 font-thin text-[16px] px-4 hover:no-underline hover:text-white focus:text-white active:text-white inline-flex items-center justify-center h-[50px] rounded-md"
                      >
                        {sub.buttonText || "Know More"}
                      </Link>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="lg:w-[50%] md:w-full w-full h-full lg:pr-20">
                    {idx === 0 && (
                      <div className="flex lg:items-start md:items-start items-center lg:justify-normal md:justify-normal justify-center gap-2 lg:-ml-20 lg:mb-8 mb-6">
                        <div className="w-20 h-[2px] bg-[#aca9a5]"></div>
                        <h2 className="text-xl font-thin text-[#74716d] uppercase leading-none -mt-1">
                          SUBSIDIARIES
                        </h2>
                      </div>
                    )}
                    <div className="h-full flex flex-col lg:items-start md:items-start items-center justify-center">
                      <img src={sub.logo} alt="" className="w-56" />
                      <p className="text-[#74716d] text-[16px] leading-[24px] font-thin lg:mt-8 md:mt-8 mt-8 lg:text-left md:text-left text-center">
                        {sub.description}
                      </p>
                      <Link
                        to={sub.link}
                        target="_blank"
                        className={`bg-[#aca9a5] ${idx === subsidiaries.length - 1 ? "border border-[#aca9a5]" : ""} inline-flex items-center justify-center uppercase rounded-md text-white mt-8 font-thin text-[16px] px-4 hover:no-underline hover:text-white focus:text-white active:text-white h-[50px]`}
                      >
                        {sub.buttonText || "Know More"}
                      </Link>
                    </div>
                  </div>
                  <div className="lg:w-[50%] md:w-full w-full h-full">
                    <img src={sub.image} alt="" className="lg:hidden" />
                  </div>
                </>
              )}
            </div>
          </section>
        );
      })}

      <div className="flex flex-col items-center justify-center py-20">
        <a
          href="#banner"
          className="text-[#74716d] hover:no-underline hover:text-[#74716d]"
        >
          Go To Top
        </a>
        <div className="w-[2px] h-14 bg-[#aca9a5]"></div>
      </div>
    </div>
  );
};

export default About;
